import * as types from './types';
import { determineTicketDisplayNameForHeader, showNotification } from '../util';
import { extractTicketFromStateById } from '../extractFromState';
import { validCommunicationType } from '../constants/conversationTypes';
import { getTextFromPTagRegex } from '../constants/regex';
import cloneDeep from 'lodash/cloneDeep';
import { TICKET_STATUS_NOMINATED } from 'constants/ticketStatuses';
import { isLiveChat } from 'util/chat';

export const newNominationNotifications = (ticketId) => (dispatch, getState) => {
  const ticketInState = extractTicketFromStateById(getState(), ticketId);
  if (!ticketInState) {
    throw new Error(`ticket ${ticketId} does not exist`);
  }

  const ticket = cloneDeep(ticketInState);
  // protects against re-assigned chats having ASSIGNED status
  ticket.ticketStatus = TICKET_STATUS_NOMINATED;

  const messageBody = getTextFromPTagRegex(ticket.ticketBody);

  const title = ticket.subject ? `Incoming Ticket - ${ticket.subject}` : 'Incoming Ticket';
  const audioFileMap = {
    [validCommunicationType.EMAIL_MESSAGE]: `/sounds/nominated_notification.mp3`,
    [validCommunicationType.WEB_CHAT]: `/sounds/nominated_chat_notification.mp3`,
    [validCommunicationType.ASYNC_CHAT]: `/sounds/nominated_chat_notification.mp3`,
    [validCommunicationType.SMS_MESSAGE]: `/sounds/nominated_chat_notification.mp3`,
    default: '/sounds/nominated_chat_notification.mp3',
  };

  const audioFile = audioFileMap[ticket.communicationType] || audioFileMap.default;

  showNotification(title, messageBody, audioFile);
  dispatch({
    type: types.ADD_UNREAD_NOMINATED_TICKET_ID,
    ticketId,
  });

  if (isLiveChat(ticket.communicationType)) {
    dispatch(addNotification(ticket));
  }
};

export const createNotification = (ticket, isOutbound) => {
  const title = determineTicketDisplayNameForHeader(ticket, true);

  return {
    ticketId: ticket.ticketId,
    title,
    body: ticket.lastCustomerMessageBody || ticket.ticketBody,
    isOutbound,
    ticketStatus: ticket.ticketStatus,
  };
};

export const addNotification = (ticket, isOutbound) => ({
  type: types.ADD_NOTIFICATION,
  notification: createNotification(ticket, isOutbound),
});

export const removeNotification = (ticketId) => ({
  type: types.REMOVE_NOTIFICATION,
  ticketId,
});
